import produce from 'immer';
import {
  ADD_FILE_SUCCESS,
  CHANGE_STATE,
  COPY_FOLDER_SUCCESS,
  CREATE_FOLDER,
  CREATE_FOLDER_FAILED,
  CREATE_FOLDER_SUCCESS,
  DELETE_FOLDER_SUCCESS,
  FETCH_FOLDERS,
  FETCH_FOLDERS_FAILED,
  FETCH_FOLDERS_SUCCESS,
  FILES_INFO_SUCCESS,
  MOVE_FOLDER_SUCCESS,
  UPDATE_FOLDER,
  UPDATE_FOLDER_SUCCESS,
  UPLOAD,
  UPLOAD_FAILED,
  UPLOAD_SUCCESS,
} from 'actions/filesAction';

export const initialState = {
  folders: [],
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  submitting: false,
  uploadSuccess: false,
  uploadedFile: null,
  uploadedFiles: [],
  failedFiles: [],
  createSuccess: false,
  createFailed: false,
  createError: '',
  total: 0,
  moveSuccess: false,
  info: {
    unarchived: {
      folders: 0,
      files: 0,
      size: 0,
    },
    post: {
      folders: 0,
      files: 0,
      size: 0,
    },
    information: {
      folders: 0,
      files: 0,
      size: 0,
    },
  },
};

/* eslint-disable default-case, no-param-reassign */
const filesReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_FOLDERS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        break;

      case FETCH_FOLDERS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.folders = action.folders;
        draft.total = action.total;
        break;

      case FETCH_FOLDERS_FAILED:
        draft.fetching = false;
        draft.fetchSuccess = false;
        draft.fetchFailed = true;
        draft.statusText = action.statusText;
        break;

      case CREATE_FOLDER:
        draft.submitting = true;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        break;
      case CREATE_FOLDER_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;
        draft.folders.push(action.pageFolder);
        draft.created = action.pageFolder;
        draft.createError = '';
        break;
      case CREATE_FOLDER_FAILED:
        draft.submitting = false;
        draft.createFailed = true;
        draft.createSuccess = false;
        draft.createError = action.error;
        break;

      case UPLOAD:
        draft.uploadSuccess = false;
        break;
      case UPLOAD_SUCCESS:
        console.log('upload success on reducer', action.file);
        draft.uploadSuccess = true;
        draft.uploadedFile = action.file;
        draft.uploadedFiles.push(action.file);
        break;
      case UPLOAD_FAILED:
        draft.uploadSuccess = false;
        draft.failedFiles.push(action.file);
        break;

      case CHANGE_STATE:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        draft.moveSuccess = false;
        break;
      case UPDATE_FOLDER:
        draft.submitting = true;
        draft.createFailed = false;
        draft.createSuccess = false;
        draft.createError = '';
        break;

      case MOVE_FOLDER_SUCCESS:
      case COPY_FOLDER_SUCCESS:
        draft.moveSuccess = true;
        break;

      case DELETE_FOLDER_SUCCESS:
        draft.folders = draft.folders.filter(
          (f) => f._id !== action.folder._id
        );
        break;
      case UPDATE_FOLDER_SUCCESS:
        draft.submitting = false;
        draft.createFailed = false;
        draft.createSuccess = true;

        if (action.folder.isDeleted) {
          draft.folders = draft.folders.filter(
            (folder) => folder._id !== action.folder._id
          );

          draft.folders = draft.folders.map((folder) =>
            folder.name === 'Trash' && folder.isSpecial
              ? {
                  ...folder,
                  files: [...folder.files, action.folder],
                  nestedFiles: [...folder.nestedFiles, action.folder],
                }
              : folder
          );
        } else {
          draft.folders = draft.folders.map((folder) =>
            folder._id === action.folder._id
              ? {
                  ...action.folder,
                  files: folder.files,
                  nestedFiles: folder.nestedFiles,
                  posts: folder.posts,
                }
              : folder
          );
        }

        draft.createError = '';
        break;

      case FILES_INFO_SUCCESS:
        draft.info = action.info;
        break;

      case ADD_FILE_SUCCESS:
        draft.folders.push(action.file);
        break;
    }
  });

export default filesReducer;
